import { Menu, MenuItem, Typography } from '@mui/material';
import { DotsHorizontal } from 'components/SVG';
import { usePopover } from 'hooks/common';
import React from 'react';
import { IconButtonWrapper } from 'sharedComponents/UI';
import { ListOptionsType } from 'types/common/DropdownOption';

type BoardNodeOptionsProps = {
  options: ListOptionsType[];
};

const BoardNodeOptions = ({ options }: BoardNodeOptionsProps) => {
  const { anchorEl, open, openPopover, closePopover } = usePopover();

  const handleClick = (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>,
    onClick: Function
  ) => {
    e.stopPropagation();
    e.preventDefault();
    closePopover();
    onClick();
  };

  return (
    <>
      <IconButtonWrapper
        onClick={openPopover}
        sx={{ margin: 0, '& path': { stroke: 'black' }, border: 'none' }}
      >
        <DotsHorizontal />
      </IconButtonWrapper>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options.map((option) => (
          <MenuItem
            onClick={(e) => handleClick(e, option.onClick)}
            key={option.tag}
          >
            {option.icon}
            <Typography sx={{ marginLeft: 1 }} component='span' variant='body1'>
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default BoardNodeOptions;
